import {
  Box,
  Chip,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import CancelIcon from "../../../assets/icons/cross-bold-icon.png";
import CustomCheckBox from "../../../components/checkbox";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useContext } from "react";
import { AppContext } from "../../../lib/Context";
import { selectedContractLength } from "../../../utils/helper";
import moment from "moment";

const useStyle = {
  datePickerStyle: {
    width: "100%",
    "&.MuiFormControl-root .MuiInputBase-root": {
      borderRadius: "4px",
      backgroundColor: "#d4ecff87",
      borderLeft: "none",
    },
  },
};

const SOGEA_VALUES = ["SOGEA", "FTTC", "FTTP", "SOADSL"];

const ConnectionBox = ({
  valll,
  mainIndex,
  renderCliOptions,
  handeDeleteCliBox,
  handleDisableLine,
  handleChangeCliNumber,
  handleChangeLineValue,
  handleChangeAddress,
  renderCliLines,
  handleChangeUpgradeCharge,
  handleSelectUpgradeAttachedValue,
  handleUpdateNumber,
  handleSelectTimePeriod,
  handleSelectPaymentWauy,
  renderEngineerSiteVisitOptions,
  handleUpdateSaleType,
}) => {
  const location = useLocation();
  const { palette } = useTheme();
  let allLines = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const { contractLength } = useContext(AppContext);
  const isDetailPage = location.pathname === "/prospect-details";

  const selectedLength = selectedContractLength(contractLength);

  return (
    <Box
      key={mainIndex}
      p={2}
      position={"relative"}
      border={`1px solid ${palette.primary.main}`}
    >
      {/* cancel button */}
      {mainIndex !== 0 && (
        <IconButton
          onClick={() => {
            if (!isDetailPage) {
              handeDeleteCliBox(mainIndex);
            }
          }}
          sx={{ position: "absolute", top: 4, right: 4 }}
        >
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Stack direction={"row"} spacing={1} alignItems={"center"} mb={2}>
            {/* Check number  */}
            <CustomCheckBox
              isChecked={valll.cliNumber}
              handleChecked={() => {
                if (!isDetailPage) {
                  handleDisableLine(mainIndex);
                }
              }}
            />
            <Typography variant="h6" fontWeight={500} color={"text.davyGrey"}>
              {valll.cliNumber
                ? `CLI Phone Number 
              ${mainIndex + 1}`
                : "CLI N/A"}
            </Typography>
          </Stack>
          {/* Number fields */}
          <TextInput
            readonly={!valll.cliNumber || isDetailPage}
            variant={"filled"}
            type={"number"}
            placeholder={"Enter number"}
            value={valll.mobileNo}
            onChange={(e) => handleChangeCliNumber(mainIndex, e.target.value)}
          />

          {valll.cliNumber && !valll.legacyTariff?.isSelected && (
            <Chip
              label={"update number"}
              variant="outlined"
              onClick={() => {
                if (!isDetailPage) {
                  handleUpdateNumber(mainIndex);
                }
              }}
              sx={{
                mt: 1,
                color: "secondary.light",
                background: (theme) => theme.palette.gradient.button,
                borderColor: "secondary.light",
              }}
            />
          )}

          {/* lines options */}
          <CustomDropDown
            variant="filled"
            sx={{ my: "20px" }}
            value={valll.line}
            onChange={(e) => handleChangeLineValue(mainIndex, e.target.value)}
            readonly={isDetailPage}
          >
            {allLines.map((line) => (
              <MenuItem key={line} value={line}>
                {line}
              </MenuItem>
            ))}
          </CustomDropDown>

          {/* options tariff */}
          <Stack spacing={1}>
            {/* allow legacy tarrif */}
            {renderCliOptions(mainIndex, valll.legacyTariff)}

            {/* allow digital tarrif */}
            {renderCliOptions(mainIndex, valll.digitalTariff)}
            {/* allow addition services */}
            {renderCliOptions(mainIndex, valll.additionalService)}

            <Divider sx={{ mb: "8px !important" }} />
            <Stack
              gap={1}
              direction={"row"}
              alignItems={"center"}
              flexWrap={"wrap"}
              // justifyContent={"space-between"}
            >
              {/* allow platform upgrade charge  */}
              {!valll.legacyTariff?.isSelected &&
                renderEngineerSiteVisitOptions(
                  mainIndex,
                  valll.upgradeCharge,
                  valll.cliNumber,
                )}

              {/* allow platform migration charge  */}
              {!valll.legacyTariff?.isSelected &&
                renderEngineerSiteVisitOptions(
                  mainIndex,
                  valll?.migration,
                  valll?.cliNumber,
                )}

              {/* allow platform transfer*/}
              {renderEngineerSiteVisitOptions(
                mainIndex,
                valll.transfer,
                valll.cliNumber,
              )}
            </Stack>

            {/* show editable text box to updare upgrade charge */}

            {valll.upgradeCharge.isSelected && (
              <>
                <Stack direction={"row"} alignItems={"center"} gap={3}>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll.upgradeCharge.timePeriod === "AM"}
                      handleChecked={() => {
                        if (!isDetailPage) {
                          handleSelectTimePeriod(
                            mainIndex,
                            "AM",
                            valll.upgradeCharge.type,
                            "timePeriod",
                          );
                        }
                      }}
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      AM
                    </Typography>
                  </Stack>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll.upgradeCharge.timePeriod === "PM"}
                      handleChecked={() => {
                        if (!isDetailPage) {
                          handleSelectTimePeriod(
                            mainIndex,
                            "PM",
                            valll.upgradeCharge.type,
                            "timePeriod",
                          );
                        }
                      }}
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      PM
                    </Typography>
                  </Stack>
                </Stack>

                {/* <Stack
                  direction={"row"}
                  spacing={1}
                  alignItems={"center"}
                  sx={{ marginTop: "16px !important" }}
                >import { dayjs } from 'dayjs';

                  <CustomCheckBox isChecked={valll.upgradeCharge.upPayment} />
                  <Typography variant="body1" color={"text.davyGrey"}>
                    Upfront Payment Collected ?
                  </Typography>
                </Stack> */}
                {/* <Typography variant="body1" color={"text.davyGrey"}>
                  Upfront Payment Collected ?
                </Typography> */}

                {/* <Stack direction={"row"} alignItems={"center"} gap={3}>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll.upgradeCharge.isCollected === "Yes"}
                      handleChecked={() =>
                        handleSelectTimePeriod(
                          mainIndex,
                          "Yes",
                          valll.upgradeCharge.type,
                          "isCollected"
                        )
                      }
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      Yes
                    </Typography>
                  </Stack>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll.upgradeCharge.isCollected === "No"}
                      handleChecked={() =>
                        handleSelectTimePeriod(
                          mainIndex,
                          "No",
                          valll.upgradeCharge.type,
                          "isCollected"
                        )
                      }
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      No
                    </Typography>
                  </Stack>
                </Stack> */}

                <TextInput
                  variant={"filled"}
                  type={"number"}
                  value={valll.upgradeCharge.salePrice}
                  onChange={(e) =>
                    handleChangeUpgradeCharge(
                      mainIndex,
                      e.target.value,
                      valll.upgradeCharge.type,
                    )
                  }
                  readonly={isDetailPage}
                />
                <CustomDropDown
                  variant={"filled"}
                  value={valll.upgradeCharge.attachedValue}
                  onChange={(e) => {
                    handleSelectUpgradeAttachedValue(
                      mainIndex,
                      e.target.value,
                      valll.upgradeCharge.type,
                    );
                  }}
                  readonly={isDetailPage}
                >
                  {SOGEA_VALUES.map((list, _ind) => {
                    return (
                      <MenuItem key={_ind} value={list}>
                        {list}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>

                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <CustomCheckBox
                    isChecked={valll?.upgradeCharge?.isImmediate}
                    handleChecked={() => {
                      if (!isDetailPage && selectedLength?.value !== 12) {
                        handleUpdateSaleType(
                          mainIndex,
                          !valll?.upgradeCharge?.isImmediate,
                          valll.upgradeCharge.type,
                          "isImmediate",
                        );
                      }
                    }}
                  />
                  <Typography variant="body1" color={"text.davyGrey"}>
                    Immediate
                  </Typography>
                </Stack>

                {!valll?.upgradeCharge?.isImmediate && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography variant="body2">Set Live Date</Typography>
                    <DatePicker
                      sx={useStyle.datePickerStyle}
                      minDate={dayjs()}
                      maxDate={
                        selectedLength?.value === 18
                          ? dayjs().add(6, "month")
                          : null
                      }
                      value={
                        valll?.upgradeCharge?.liveDate
                          ? dayjs(valll?.upgradeCharge?.liveDate)
                          : null
                      }
                      readOnly={isDetailPage || selectedLength?.value === 12}
                      format="DD.MM.YY"
                      disablePast={true}
                      onChange={(newValue) => {
                        handleUpdateSaleType(
                          mainIndex,
                          newValue?.$d,
                          valll.upgradeCharge.type,
                          "liveDate",
                        );
                      }}
                    />
                  </LocalizationProvider>
                )}
              </>
            )}

            {valll?.migration?.isSelected && (
              <>
                <Stack direction={"row"} alignItems={"center"} gap={3}>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll?.migration?.timePeriod === "AM"}
                      handleChecked={() => {
                        if (!isDetailPage) {
                          handleSelectTimePeriod(
                            mainIndex,
                            "AM",
                            valll?.migration?.type,
                            "timePeriod",
                          );
                        }
                      }}
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      AM
                    </Typography>
                  </Stack>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll?.migration?.timePeriod === "PM"}
                      handleChecked={() => {
                        if (!isDetailPage) {
                          handleSelectTimePeriod(
                            mainIndex,
                            "PM",
                            valll?.migration?.type,
                            "timePeriod",
                          );
                        }
                      }}
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      PM
                    </Typography>
                  </Stack>
                </Stack>

                {/* <Stack direction={"column"} gap={1} my={2}> */}
                {/* <Box> */}
                {/* <Stack direction={"row"} spacing={1} alignItems={"center"}>
                      <CustomCheckBox
                        isChecked={valll?.migration?.upPayment}
                        handleChecked={() =>
                          handleSelectPaymentWauy(
                            mainIndex,
                            valll?.migration?.type,
                            "up"
                          )
                        }
                      />
                      <Typography variant="body1" color={"text.davyGrey"}>
                        Upfront Payment Collected ?
                      </Typography>
                    </Stack> */}

                {/* <Typography variant="body1" color={"text.davyGrey"}>
                      Upfront Payment Collected ?
                    </Typography> */}

                {/* {valll?.migration?.upPayment && ( */}
                {/* <Stack
                      direction={"row"}
                      alignItems={"center"}
                      gap={3}
                      mt={1}
                    >
                      <Stack
                        direction={"row"}
                        spacing={1}
                        alignItems={"center"}
                      >
                        <CustomCheckBox
                          isChecked={valll.migration.isCollected === "Yes"}
                          handleChecked={() =>
                            handleSelectTimePeriod(
                              mainIndex,
                              "Yes",
                              valll.migration.type,
                              "isCollected"
                            )
                          }
                        />
                        <Typography variant="body1" color={"text.davyGrey"}>
                          Yes
                        </Typography>
                      </Stack>
                      <Stack
                        direction={"row"}
                        spacing={1}
                        alignItems={"center"}
                      >
                        <CustomCheckBox
                          isChecked={valll.migration.isCollected === "No"}
                          handleChecked={() =>
                            handleSelectTimePeriod(
                              mainIndex,
                              "No",
                              valll.migration.type,
                              "isCollected"
                            )
                          }
                        />
                        <Typography variant="body1" color={"text.davyGrey"}>
                          No
                        </Typography>
                      </Stack>
                    </Stack> */}
                {/* )} */}
                {/* </Box> */}

                {/* <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <CustomCheckBox
                      isChecked={valll?.migration?.firstMonth}
                      handleChecked={() =>
                        handleSelectPaymentWauy(
                          mainIndex,
                          valll?.migration?.type,
                          "first"
                        )
                      }
                    />
                    <Typography variant="body1" color={"text.davyGrey"}>
                      Add in first month invoice
                    </Typography>
                  </Stack> */}
                {/* </Stack> */}

                <TextInput
                  variant={"filled"}
                  type={"number"}
                  value={valll?.migration?.salePrice}
                  onChange={(e) =>
                    handleChangeUpgradeCharge(
                      mainIndex,
                      e.target.value,
                      valll?.migration?.type,
                    )
                  }
                  readonly={isDetailPage}
                />
                <CustomDropDown
                  variant={"filled"}
                  value={valll.migration.attachedValue}
                  onChange={(e) => {
                    handleSelectUpgradeAttachedValue(
                      mainIndex,
                      e.target.value,
                      valll.migration.type,
                    );
                  }}
                  readonly={isDetailPage}
                >
                  {SOGEA_VALUES.map((list, _ind) => {
                    return (
                      <MenuItem key={_ind} value={list}>
                        {list}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>

                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <CustomCheckBox
                    isChecked={valll?.migration?.isImmediate}
                    handleChecked={() => {
                      if (!isDetailPage && selectedLength?.value !== 12) {
                        handleUpdateSaleType(
                          mainIndex,
                          !valll?.migration?.isImmediate,
                          valll.migration.type,
                          "isImmediate",
                        );
                      }
                    }}
                  />
                  <Typography variant="body1" color={"text.davyGrey"}>
                    Immediate
                  </Typography>
                </Stack>

                {!valll?.migration?.isImmediate && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography variant="body2">Set Live Date</Typography>
                    <DatePicker
                      sx={useStyle.datePickerStyle}
                      value={
                        valll?.migration?.liveDate
                          ? dayjs(valll?.migration?.liveDate)
                          : null
                      }
                      minDate={dayjs()}
                      maxDate={
                        selectedLength?.value === 18
                          ? dayjs().add(6, "month")
                          : null
                      }
                      readOnly={isDetailPage}
                      format="DD.MM.YY"
                      disablePast={true}
                      onChange={(newValue) => {
                        handleUpdateSaleType(
                          mainIndex,
                          newValue?.$d,
                          valll.migration.type,
                          "liveDate",
                        );
                      }}
                    />
                  </LocalizationProvider>
                )}
              </>
            )}

            {valll?.transfer?.isSelected && (
              <>
                {/* <TextInput
                  variant={"filled"}
                  type={"number"}
                  value={valll?.transfer?.salePrice}
                  onChange={(e) =>
                    handleChangeUpgradeCharge(
                      mainIndex,
                      e.target.value,
                      valll?.transfer?.type
                    )
                  }
                /> */}
                <CustomDropDown
                  variant={"filled"}
                  value={valll.transfer.attachedValue}
                  onChange={(e) => {
                    handleSelectUpgradeAttachedValue(
                      mainIndex,
                      e.target.value,
                      valll.transfer.type,
                    );
                  }}
                  readonly={isDetailPage}
                >
                  <MenuItem value={"LEGACY"}>LEGACY</MenuItem>
                  {SOGEA_VALUES.map((list, _ind) => {
                    return (
                      <MenuItem key={_ind} value={list}>
                        {list}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>

                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <CustomCheckBox
                    isChecked={valll?.transfer?.isImmediate}
                    handleChecked={() => {
                      if (!isDetailPage && selectedLength?.value !== 12) {
                        handleUpdateSaleType(
                          mainIndex,
                          !valll?.transfer?.isImmediate,
                          valll.transfer.type,
                          "isImmediate",
                        );
                      }
                    }}
                  />
                  <Typography variant="body1" color={"text.davyGrey"}>
                    Immediate
                  </Typography>
                </Stack>

                {!valll?.transfer?.isImmediate && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography variant="body2">Set Live Date</Typography>
                    <DatePicker
                      sx={useStyle.datePickerStyle}
                      value={
                        valll?.transfer?.liveDate
                          ? dayjs(valll?.transfer?.liveDate)
                          : null
                      }
                      minDate={dayjs()}
                      maxDate={
                        selectedLength?.value === 18
                          ? dayjs().add(6, "month")
                          : null
                      }
                      readOnly={isDetailPage}
                      format="DD.MM.YY"
                      disablePast={true}
                      onChange={(newValue) => {
                        handleUpdateSaleType(
                          mainIndex,
                          newValue?.$d,
                          valll?.transfer?.type,
                          "liveDate",
                        );
                      }}
                    />
                  </LocalizationProvider>
                )}
              </>
            )}

            {mainIndex !== 0 && (
              <>
                {renderCliOptions(mainIndex, valll.differentAddress)}
                {/* Textarea Box */}
                {valll.differentAddress.isSelected && (
                  <TextInput
                    variant={"filled"}
                    value={valll.differentAddress.value}
                    placeholder={"Enter Address"}
                    onChange={(e) =>
                      handleChangeAddress(mainIndex, e.target.value)
                    }
                    multiline
                    rows={2}
                    style={{
                      "& .MuiInputBase-multiline": {
                        padding: "0px",
                      },
                    }}
                    readonly={isDetailPage}
                  />
                )}
              </>
            )}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={9}
          display={"flex"}
          gap={3}
          overflow={"auto"}
          pb={1}
        >
          {renderCliLines(valll, mainIndex)}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConnectionBox;
